import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c090196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import HomeHeader from '@/components/HomeHeader.vue' // @ is an alias to /src
import Footer from '@/components/Footer.vue' // @ is an alias to /src
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore()
const isMobile = store.state.isMobile


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['home-wrap', { 'phoneContainer': _unref(isMobile) }])
  }, [
    _createVNode(HomeHeader),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(Footer)
  ], 2))
}
}

})